export default {
  FRONT: "Front",
  BACK: "Back",
  TOTAL: "Total",
};
